import Cookies from 'js-cookie';

export const getTheme = () => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith('theme='))
    ?.split('=')[1];
};

export const setTheme = (themeValue: string) => {
  Cookies.set('theme', themeValue, { expires: 365, path: '/' });
};
